<div class="modal-header">
  <h5 class="modal-title" i18n>Select Rental to Copy</h5>
  <button (click)="close()" type="button" class="close">
    <i class="far fa-times"></i>
  </button>
</div>
<div class="modal-body" [formGroup]="form">
  <div class="row">
    <div class="col-sm-8">
      <app-rental-select
        [items]="data.rentals"
        [ctrl]="form.get('rentalId')"
        [multiple]="false"
        i18n-placeholder
        placeholder="Select Rental"
      >
      </app-rental-select>
    </div>
  </div>
  <p i18n>Please select which information you want to copy.</p>
  <div class="row">
    <div class="col-sm-6">
      <mat-checkbox formControlName="checkInInstructions" i18n>Check-in Instructions</mat-checkbox>
    </div>
    <div class="col-sm-6">
      <mat-checkbox formControlName="checkOutInstructions" i18n>Check-out Instructions</mat-checkbox>
    </div>
    <div class="col-sm-6">
      <mat-checkbox formControlName="directionInstructions" i18n>Directions</mat-checkbox>
    </div>
    <div class="col-sm-6">
      <mat-checkbox formControlName="houseRules" i18n>House Rules</mat-checkbox>
    </div>
    <div class="col-sm-6">
      <mat-checkbox formControlName="specialInstructions" i18n>Special Instructions</mat-checkbox>
    </div>
    <div class="col-sm-6">
      <mat-checkbox formControlName="paymentTerms" i18n>Payment Terms</mat-checkbox>
    </div>
    <div class="col-sm-6">
      <mat-checkbox formControlName="paymentInstructions" i18n>Payment Instructions</mat-checkbox>
    </div>
    <div class="col-sm-6">
      <mat-checkbox formControlName="checkTimes" i18n>Check-in/Check-out Times</mat-checkbox>
    </div>
    <div class="col-sm-6">
      <mat-checkbox formControlName="codes" i18n>Codes & Passwords</mat-checkbox>
    </div>
  </div>
  <p *ngIf="form.touched && form.invalid" class="text-danger" i18n>
    Please select at least one item to copy from other rental.
  </p>
</div>
<div class="modal-footer">
  <button (click)="close()" type="button" class="btn btn-light">
    <i class="far fa-times"></i> <ng-container i18n>Cancel</ng-container>
  </button>
  <button (click)="save(form)" type="button" class="btn btn-secondary-info create-btn">
    <i class="cs-icon cs-icon-save"></i> <ng-container i18n>Select</ng-container>
  </button>
</div>
